import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import { API_URL } from "../../config/config"; // Adjust path based on your project structure

const API_URL = process.env.REACT_APP_API_URL;

// Helper to get token from sessionStorage (preferred) or localStorage (fallback)
const getAuthToken = (getState) =>
  (getState && getState().auth && getState().auth.token) ||
  sessionStorage.getItem("access_token") ||
  localStorage.getItem("access_token");

// Thunks
export const fetchRecentActivityTrack = createAsyncThunk(
  "activityTrack/fetchRecentActivityTrack",
  async (patientId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(
        `${API_URL}/activity/activity-track-recent/${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);

export const fetchAllActivityTracks = createAsyncThunk(
  "activityTrack/fetchAllActivityTracks",
  async (patientId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(
        `${API_URL}/activity/activity_tracks/${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to fetch today's activity track data
export const fetchTodaysActivityTrack = createAsyncThunk(
  "activityTrack/fetchTodaysActivityTrack",
  async (patientId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(
        `${API_URL}/activity/Todays-activity-tracks/${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);

// Slice with nested state structure
const activityTrackSlice = createSlice({
  name: "activityTrack",
  initialState: {
    recent: {
      data: null,
      loading: false,
      error: null,
    },
    all: {
      activityTrack: [],
      loading: false,
      error: null,
    },
    today: {
      activityTrack: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    // Clear error action for the nested state
    clearError: (state, action) => {
      const { target } = action.payload;
      if (target === "recent") state.recent.error = null;
      if (target === "all") state.all.error = null;
      if (target === "today") state.today.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetching recent activity track
      .addCase(fetchRecentActivityTrack.pending, (state) => {
        state.recent.loading = !state.recent.data;
        state.recent.error = null;
      })
      .addCase(fetchRecentActivityTrack.fulfilled, (state, action) => {
        state.recent.loading = false;
        state.recent.data = action.payload;
      })
      .addCase(fetchRecentActivityTrack.rejected, (state, action) => {
        state.recent.loading = false;
        state.recent.error = action.payload;
      })
      // Fetching all activity tracks
      .addCase(fetchAllActivityTracks.pending, (state) => {
        state.all.loading = true;
        state.all.error = null;
      })
      .addCase(fetchAllActivityTracks.fulfilled, (state, action) => {
        state.all.loading = false;
        state.all.activityTrack = action.payload;
      })
      .addCase(fetchAllActivityTracks.rejected, (state, action) => {
        state.all.loading = false;
        state.all.error = action.payload;
      })
      // Fetching today's activity track
      .addCase(fetchTodaysActivityTrack.pending, (state) => {
        state.today.loading = true;
        state.today.error = null;
      })
      .addCase(fetchTodaysActivityTrack.fulfilled, (state, action) => {
        state.today.loading = false;
        state.today.activityTrack = action.payload;
      })
      .addCase(fetchTodaysActivityTrack.rejected, (state, action) => {
        state.today.loading = false;
        state.today.error = action.payload;
      });
  },
});

// Export the clearError action
export const { clearError } = activityTrackSlice.actions;
export default activityTrackSlice.reducer;




// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// // import { API_URL } from "../../config/config"; // Adjust path based on your project structure

// const API_URL = process.env.REACT_APP_API_URL;

// // Thunks
// export const fetchRecentActivityTrack = createAsyncThunk(
//   "activityTrack/fetchRecentActivityTrack",
//   async (patientId, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/activity/activity-track-recent/${patientId}`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.detail || error.message);
//     }
//   }
// );

// export const fetchAllActivityTracks = createAsyncThunk(
//   "activityTrack/fetchAllActivityTracks",
//   async (patientId, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/activity/activity_tracks/${patientId}`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // Thunk to fetch today's activity track data
// export const fetchTodaysActivityTrack = createAsyncThunk(
//   "activityTrack/fetchTodaysActivityTrack",
//   async (patientId, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/activity/Todays-activity-tracks/${patientId}`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.detail || error.message);
//     }
//   }
// );

// // Slice with nested state structure
// const activityTrackSlice = createSlice({
//   name: "activityTrack",
//   initialState: {
//     recent: {
//       data: null,
//       loading: false,
//       error: null,
//     },
//     all: {
//       activityTrack: [],
//       loading: false,
//       error: null,
//     },
//     today: {
//       activityTrack: [],
//       loading: false,
//       error: false,
//     },
//   },
//   reducers: {
//     // Clear error action for the nested state
//     clearError: (state, action) => {
//       const { target } = action.payload;
//       if (target === "recent") state.recent.error = null;
//       if (target === "all") state.all.error = null;
//       if (target === "today") state.today.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // Fetching recent activity track
//       .addCase(fetchRecentActivityTrack.pending, (state) => {
//         if (!state.recent.data) {
//           // Only show loading indicator if no data yet (initial load)
//           state.recent.loading = true;
//         } else {
//           // Keep loading false if data already exists (background refresh)
//           state.recent.loading = false;
//         }
//         state.recent.error = null;
//       })

//       .addCase(fetchRecentActivityTrack.fulfilled, (state, action) => {
//         state.recent.loading = false;
//         state.recent.data = action.payload;
//       })
//       .addCase(fetchRecentActivityTrack.rejected, (state, action) => {
//         state.recent.loading = false;
//         state.recent.error = action.payload;
//       })
//       // Fetching all activity tracks
//       .addCase(fetchAllActivityTracks.pending, (state) => {
//         state.all.loading = true;
//         state.all.error = null;
//       })
//       .addCase(fetchAllActivityTracks.fulfilled, (state, action) => {
//         state.all.loading = false;
//         state.all.activityTrack = action.payload;
//       })
//       .addCase(fetchAllActivityTracks.rejected, (state, action) => {
//         state.all.loading = false;
//         state.all.error = action.payload;
//       })
//       // Fetching today's activity track
//       .addCase(fetchTodaysActivityTrack.pending, (state) => {
//         state.today.loading = true;
//         state.today.error = null;
//       })
//       .addCase(fetchTodaysActivityTrack.fulfilled, (state, action) => {
//         state.today.loading = false;
//         state.today.activityTrack = action.payload;
//       })
//       .addCase(fetchTodaysActivityTrack.rejected, (state, action) => {
//         state.today.loading = false;
//         state.today.error = action.payload;
//       });
//   },
// });

// // Export the clearError action
// export const { clearError } = activityTrackSlice.actions;

// export default activityTrackSlice.reducer;
